import { HighYieldSavings, HighYieldSavingsProducts } from './dialogContent';

export const InfographicComponentVariant = {
  hysa_infographic: 'hysa_infographic',
  high_yield_savings_products: 'high_yield_savings_products',
} as const;

export type InfographicComponentVariant =
  (typeof InfographicComponentVariant)[keyof typeof InfographicComponentVariant];

export const VARIANT_COMPONENT_MAP = {
  [InfographicComponentVariant.hysa_infographic]: HighYieldSavings,
  [InfographicComponentVariant.high_yield_savings_products]: HighYieldSavingsProducts,
} as const;

export const VARIANT_TITLE_MAP: Record<InfographicComponentVariant, string> = {
  [InfographicComponentVariant.hysa_infographic]:
    'You could earn thousands with a high-yield savings account!',
  [InfographicComponentVariant.high_yield_savings_products]:
    'You could earn thousands with a high-yield savings product!',
};

export const VARIANT_HIGH_YIELD_LABEL_MAP: Record<InfographicComponentVariant, string> = {
  [InfographicComponentVariant.hysa_infographic]: 'High yield savings account',
  [InfographicComponentVariant.high_yield_savings_products]: 'High yield savings products',
};

export const VARIANT_TEST_ID_MAP: Record<InfographicComponentVariant, string> = {
  [InfographicComponentVariant.hysa_infographic]: 'student-perks-variant',
  [InfographicComponentVariant.high_yield_savings_products]:
    'high-yield-savings-products-variant',
};
